import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Maximize2 } from 'lucide-react';
import { floatingSurfaceClass } from '../floatingSurfaceStyles';

const SURFACE = floatingSurfaceClass(97);

/**
 * "Season summary" pill — sits beside Arrivals and opens the season modal.
 *
 * Same 40px/20px-radius shell as MapArrivalsStrip, because the design draws
 * them as one row of the same control. The trailing glyph is an expand arrow
 * rather than a chevron: this opens a modal over the map, where Arrivals
 * expands a panel in place, and using the same chevron for both would promise
 * the same behaviour.
 *
 * Presentational — the caller owns whether it renders at all and what opening
 * it does.
 */
const MapSeasonSummaryStrip = ({ onOpen, className = '' }) => {
  const { t } = useTranslation();

  return (
    <button
      type="button"
      onClick={onOpen}
      className={`flex h-[40px] shrink-0 cursor-pointer items-center gap-[10px] rounded-[20px] border border-solid py-0 pl-[13px] pr-[6px] ${SURFACE} ${className}`}
    >
      <Table size={16} className="shrink-0 text-[#16A34A] dark:text-[#22C55E]" />
      <span className="font-['Inter'] text-[13px] font-bold whitespace-nowrap text-[#343440] dark:text-[#E6E8E6]">
        {t('map.seasonSummary.title', 'Season summary')}
      </span>
      <span className="ml-auto flex h-[28px] w-[28px] shrink-0 items-center justify-center rounded-full bg-[#F3F5F2] dark:bg-[#252B27]">
        <Maximize2 size={13} className="text-[#5D625F] dark:text-[#9AA09A]" />
      </span>
    </button>
  );
};

export default MapSeasonSummaryStrip;
